module.exports = __webpack_public_path__ + "static/media/IC_network_of_influence.457aead9.svg";